// extracted by mini-css-extract-plugin
export default {"header":"style_header__HueCW","title":"style_title__1htIN","subtitle":"style_subtitle__NPdqu","text":"style_text__FfTpy","back_button":"style_back_button__R41Tc"};